import { DataType } from "../../../tables"
import { Driver } from "../state/types"
import { useFiltersHooks } from "../../../features/ui"
import { normalize } from "../../../utils/typeUtils"
import { useRoadmapLoaders } from "../loaders/roadmapLoaders"

export const useDriverHooks = () => {
    const { search2 } = useFiltersHooks()

    const roadmapLoaders = useRoadmapLoaders()

    const canRemoveDriver = async (driverId: string): Promise<boolean> => {
        const { countRoadmaps } = roadmapLoaders()
        const roadmapsCount = await countRoadmaps('driverId', driverId)
        return roadmapsCount === 0
    }

    const searchDrivers = (
        drivers: Driver[],
        searchText = ''
    ): Promise<Driver[]> => {
        const valuesFn = async (driverDT: DataType) => {
            const { name, identifier } = driverDT as Driver
            return [
                normalize(name),
                identifier ? identifier.toString() : ''
            ]
        }
        const sortFn = (driverDT_A: DataType, driverDT_B: DataType) => 
            (driverDT_A as Driver).name.localeCompare((driverDT_B as Driver).name)

        return search2(drivers, searchText, valuesFn, undefined, sortFn) as Promise<Driver[]>
    }

    return {
        canRemoveDriver,
        searchDrivers
    }
}
